module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/023-cocos-island-149a00353cb78b2ec4198ca8cc25964e.svg";